module.exports = __webpack_public_path__ + "img/02_more_buyers.ef8633e7.svg";